import axios from "axios";
import {API_URL} from "../../utils/const/env";
import {ADMIN_ROLES} from "../auth/roles";
import {clearAdminCountryScope, getAdminCountryScope} from "./countryScope";

export const getApiBaseUrl = () => API_URL.replace(/\/$/, "");

export const getAuthToken = () => localStorage.getItem("sorpaToken");

export const AUTH_EXPIRED_EVENT = "sorpa-admin-auth-expired";
export const SECURITY_EXIT_EVENT = "sorpa-admin-security-exit";

export const clearStoredAdminSession = () => {
    localStorage.removeItem("sorpaToken");
    localStorage.removeItem("role");
    clearAdminCountryScope();
    delete axios.defaults.headers.common.Authorization;
};

export const expireAuthSession = () => {
    clearStoredAdminSession();
    window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
};

export const apiClient = axios.create({
    baseURL: getApiBaseUrl(),
    headers: {
        "Content-Type": "application/json",
    },
});

apiClient.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Token ${token}`;
    }
    const url = String(config.url || "");
    const skipAdminCountryScope = config.skipAdminCountryScope === true;
    delete config.skipAdminCountryScope;
    if (url.startsWith("/api/v2/admin/") && !skipAdminCountryScope) {
        const params = {...(config.params || {})};
        const role = localStorage.getItem("role");
        if (role !== ADMIN_ROLES.SUPERADMIN && String(params.country_id ?? "") === "0") {
            delete params.country_id;
        }
        if (params.country_id === undefined || params.country_id === null || params.country_id === "") {
            const countryScope = getAdminCountryScope();
            if (countryScope !== null) params.country_id = countryScope;
        }
        config.params = params;
    }
    return config;
});

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            expireAuthSession();
        }
        return Promise.reject(error);
    },
);

export const apiGet = async (url, config) => {
    const response = await apiClient.get(url, config);
    return response.data;
};

export const apiPost = async (url, payload, config) => {
    const response = await apiClient.post(url, payload, config);
    return response.data;
};

export const apiPut = async (url, payload, config) => {
    const response = await apiClient.put(url, payload, config);
    return response.data;
};

export const apiPatch = async (url, payload, config) => {
    const response = await apiClient.patch(url, payload, config);
    return response.data;
};

export const apiDelete = async (url, config) => {
    const response = await apiClient.delete(url, config);
    return response.data;
};
